module.exports = __webpack_public_path__ + "static/media/brand-3.a2dee7c2.png";